


































































































import Vue from "vue";
import Tabs from "@/components/Tabs.vue";
import { Grid } from "@progress/kendo-vue-grid";
import LookupComboBox from "@/modules/transactions/components/LookupComboBox.vue";
import IconButton from "@/components/IconButton.vue";
import { BookingTemplateItem, BookingTemplateItemDimension } from "../models/BookingTemplate";

// K2D "Könyvelési sablonok" tétel 4–9. dimenzió-felosztás szerkesztő (d_g_imboktranstemp_d tab-nézet),
// TransactionItemDimensionEdit mintájára, de a sablon egyszerűbb modelljére: dimCode + total (arány).
// A kiválasztott tétel dimensions[]-ét szerkeszti (dimCodeType 5..10 = IV..IX. dimenzió); mentéskor
// a SaveBookingTemplate round-trippeli (újra beszúrja az imboktranstemp_d-t).
interface TabDef {
  type: number;
  label: string;
}

interface Data {
  activeType: number;
  dimTabs: TabDef[];
  columns: any[];
}

interface Methods {
  dimsFor(type: number): BookingTemplateItemDimension[];
  dimCodesFor(type: number): any[];
  addDim(): void;
  removeDim(dim: BookingTemplateItemDimension): void;
  askDelete(dim: BookingTemplateItemDimension): void;
  confirmRemove(dim: BookingTemplateItemDimension): void;
  cancelRemove(dim: BookingTemplateItemDimension): void;
  onDimCodeChange(dim: BookingTemplateItemDimension, selected: any): void;
}

interface Props {
  side: string;
  item: BookingTemplateItem | null;
  dimensions: any[];
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "BookingTemplateItemDimensionEdit",

  components: {
    Tabs,
    Grid,
    LookupComboBox,
    IconButton,
  },

  props: {
    // "+" = tartozik, "-" = követel oldal (BookingTemplateItem.accSign).
    side: { type: String, default: "+" },
    item: { type: Object as () => BookingTemplateItem | null, default: null },
    dimensions: { type: Array as () => any[], default: () => [] },
  },

  data(): Data {
    return {
      activeType: 5,
      // dimCodeType 5..10 → IV..IX. dimenzió (a dim száma = dimCodeType - 1).
      dimTabs: [
        { type: 5, label: "IV. dimenzió" },
        { type: 6, label: "V. dimenzió" },
        { type: 7, label: "VI. dimenzió" },
        { type: 8, label: "VII. dimenzió" },
        { type: 9, label: "VIII. dimenzió" },
        { type: 10, label: "IX. dimenzió" },
      ],
      columns: [
        // Akció-oszlop balra, fejléc nélkül (TF lista/grid konvenció).
        { cell: "actionsCell", title: "", width: "80px", filterable: false, sortable: false },
        { cell: "codeCell", title: "Dimenzió kód" },
        { cell: "totalCell", title: "Szorzó", width: "150px" },
        { filterable: false, width: 0, }
      ],
    };
  },

  methods: {
    dimsFor(type: number): BookingTemplateItemDimension[] {
      return this.item ? this.item.dimensions.filter((d) => d.dimCodeType === type) : [];
    },

    // A választó a kiválasztott év dimenzió-kódjai közül az adott típusúakat mutatja (mmbokdimcode).
    dimCodesFor(type: number): any[] {
      return this.dimensions.filter((d) => d.type === type);
    },

    // Új felosztás az aktív fül dimenzió-típusával (dimCode=1 = nincs, total=0).
    addDim() {
      if (!this.item) return;
      this.item.dimensions.push({
        id: 0,
        deleting: false, // kezdőérték, hogy a törlés-megerősítő detail-sor reaktív legyen (Vue 2)
        dimCodeType: this.activeType,
        dimCode: 1,
        dimCodeDisplay: null,
        total: 0,
      });
    },

    removeDim(dim: BookingTemplateItemDimension) {
      if (!this.item) return;
      const i = this.item.dimensions.indexOf(dim);
      if (i >= 0) this.item.dimensions.splice(i, 1);
    },

    // Kuka: a soron belüli sárga törlés-megerősítő nyitása/zárása (grid törlés-konvenció;
    // egyszerre csak egy nyitva, újbóli kattintásra bezár).
    askDelete(dim: BookingTemplateItemDimension) {
      if (!this.item) return;
      const reopen = !!dim.deleting;
      this.item.dimensions.forEach((d) => (d.deleting = false));
      if (reopen) return;
      dim.deleting = true;
    },

    confirmRemove(dim: BookingTemplateItemDimension) {
      dim.deleting = false;
      this.removeDim(dim);
    },

    cancelRemove(dim: BookingTemplateItemDimension) {
      dim.deleting = false;
    },

    // A LookupComboBox a kiválasztott dimenzió-kód sort adja; 1 = nincs (K2D dimcode sentinel).
    onDimCodeChange(dim: BookingTemplateItemDimension, selected: any) {
      dim.dimCode = selected && selected.id ? selected.id : 1;
      dim.dimCodeDisplay = selected && selected.id ? selected.dimcode : null;
    },
  },

  watch: {
    // Tétel-váltáskor az első olyan fülre ugrunk, amelyiken már van felosztás; ha egyiken sincs,
    // az első fülre (TransactionItemDimensionEdit positiveNegativeItem watch mintája).
    // immediate: betöltés után az oldal első tétele már kijelölve érkezik, arra is ugorjon.
    item: {
      immediate: true,
      handler(newVal: BookingTemplateItem | null) {
        if (!newVal) return;
        const index = this.dimTabs.findIndex((t) =>
          newVal.dimensions.some((d) => d.dimCodeType === t.type)
        );
        const tabIndex = index >= 0 ? index : 0;
        this.activeType = this.dimTabs[tabIndex].type;
        // A tabs csak akkor van a DOM-ban, ha van kijelölt tétel (v-else) — null→tétel váltásnál
        // (és immediate futásnál) a ref csak a következő tickben él.
        this.$nextTick(() => {
          const tab = this.$refs.tab as any;
          if (tab) tab.setTab(tabIndex);
        });
      },
    },
  },
});
